module.exports = __webpack_public_path__ + "img/37.0edd3f00.jpg";